import {
  RouteRecordRaw, RouterOptions,
  createRouter, createWebHistory
} from 'vue-router';

import { RouterEnum } from '@interface/public';
import Config from '@constant/config';
import { canonicalSpaPath } from '@module/siteRoute';

export const RouterList: RouteRecordRaw[] = [ // 路由列表
  {
    path: RouterEnum.Root,
    name: 'router.root',
    component: () => import(/* webpackPreload: true, webpackChunkName: "pageLayout" */ '@template/page/index.vue'),
    children: [{ path: '', name: 'router.rootHome', component: () => import(/* webpackPreload: true, webpackChunkName: "home" */ '@template/page/home/home.vue') }]
  },
  {
    path: RouterEnum.Index,
    redirect: Config.Template.default,
    name: 'router.index'
  },
  {
    path: RouterEnum.Personal,
    name: 'router.personal',
    component: () => import('@template/page/personal/index.vue')
  },
  {
    path: RouterEnum.MiniJump,
    name: 'router.minijump',
    component: () => import('@template/page/minijump/index.vue')
  },
  {
    path: RouterEnum.DigitalHumanDemo,
    name: 'router.digitalHumanDemo',
    redirect: RouterEnum.Home // 下线独立 SDK 调试页，旧链接返回官网首页
  },
  {
    path: RouterEnum.Page,
    redirect: Config.Template.default,
    name: 'router.page',
    component: () => import(/* webpackPreload: true, webpackChunkName: "pageLayout" */ '@template/page/index.vue'),
    children: [
      {
        path: RouterEnum.Home,
        name: 'router.home',
        component: () => import(/* webpackPreload: true, webpackChunkName: "home" */ '@template/page/home/home.vue')
      },
      {
        path: RouterEnum.Database,
        name: 'router.database',
        beforeEnter: (to) => {
          const params = new URLSearchParams();
          if (typeof to.query.lang === 'string') params.set('lang', to.query.lang);
          window.location.replace('/database/index.html' + (params.size ? '?' + params : '') + to.hash);
          return false;
        }
      },
      {
        path: RouterEnum.Consult,
        name: 'router.consult',
        component: () => import('@template/page/consult/consult.vue')
      },
      {
        path: RouterEnum.About,
        name: 'router.about',
        component: () => import('@template/page/about/about.vue')
      },
      {
        path: RouterEnum.Community,
        name: 'router.community',
        component: () => import('@template/page/community/community.vue')
      },
      
      //----- 产品 Start -----//
      {
        path: RouterEnum.ProductSchedulX,
        name: 'router.productSchedulX',
        component: () => import('@template/page/productSchedulX/product.vue')
      },
      // {
      //     path: RouterEnum.ProductSchedulXSaaS,
      //     name: 'router.productSchedulXSaaS',
      //     component: () => import('@template/page/productSchedulXSaaS/product.vue')
      // },
      {
        path: RouterEnum.ProductCostPilot,
        name: 'router.productCostPilot',
        component: () => import('@template/page/productCostPilot/product.vue')
      },
      {
        path: RouterEnum.ProductInfraPilot,
        name: 'router.productInfraPilot',
        component: () => import('@template/page/productInfraPilot/product.vue')
      },
      {
        path: RouterEnum.ProductAIPilot,
        name: 'router.productAIPilot',
        component: () => import('@template/page/productAIPilot/product.vue')
      },
      {
        path: RouterEnum.ProductAidigitalHuman,
        name: 'router.productAidigitalHuman',
        component: () => import('@template/page/productAidigitalHuman/product.vue')
      },
      {
        path: RouterEnum.ProductPrivateAidigitalHuman,
        name: 'router.productPrivateAidigitalHuman',
        component: () => import('@template/page/productPrivateAidigitalHuman/product.vue')
      },
      {
        path: RouterEnum.Products,
        name: 'router.products',
        component: () => import('@template/page/products/index.vue')
      },
      {
        path: RouterEnum.ProductTerminal,
        name: 'router.productTerminal',
        component: () => import('@template/page/productTerminal/index.vue')
      },
      {
        path: RouterEnum.Solutions,
        name: 'router.solutions',
        component: () => import('@template/page/solutions/index.vue')
      },
      {
        path: RouterEnum.SolutionRetail,
        name: 'router.solutionRetail',
        component: () => import('@template/page/solutions/index.vue'),
        meta: { sol: 'sol1' }
      },
      {
        path: RouterEnum.SolutionGovernment,
        name: 'router.solutionGovernment',
        component: () => import('@template/page/solutions/index.vue'),
        meta: { sol: 'sol2' }
      },
      {
        path: RouterEnum.SolutionMuseum,
        name: 'router.solutionMuseum',
        component: () => import('@template/page/solutions/index.vue'),
        meta: { sol: 'sol3' }
      },
      {
        path: RouterEnum.SolutionMerchant,
        name: 'router.solutionMerchant',
        component: () => import('@template/page/solutions/index.vue'),
        meta: { sol: 'sol4' }
      },
      {
        path: RouterEnum.Cases,
        name: 'router.cases',
        component: () => import('@template/page/cases/index.vue')
      },
      {
        path: RouterEnum.Tech,
        name: 'router.tech',
        component: () => import('@template/page/tech/index.vue')
      },
      //----- 产品 End -----//
      
      //----- 解决方案 Start -----//
      {
        path: RouterEnum.PlanOperation,
        name: 'router.planOperation',
        component: () => import('@template/page/planOperation/plan.vue')
      },
      {
        path: RouterEnum.PlanTrusteeship,
        name: 'router.planTrusteeship',
        component: () => import('_Project/application/template/page/planTrusteeship/planTrusteeship.vue')
      },
      {
        path: RouterEnum.PlanCost,
        name: 'router.planCost',
        component: () => import('@template/page/planCost/plan.vue')
      },
      {
        path: RouterEnum.PlanStable,
        name: 'router.planStable',
        component: () => import('@template/page/planStable/plan.vue')
      },
      {
        path: RouterEnum.PlanMigrate,
        name: 'router.planMigrate',
        component: () => import('@template/page/planMigrate/plan.vue')
      },
      {
        path: RouterEnum.PlanActive,
        name: 'router.planActive',
        component: () => import('@template/page/planActive/plan.vue')
      },
      //----- 解决方案 End -----//
      
      //----- 新闻 Start -----//
      {
        path: RouterEnum.News,
        name: 'router.news',
        beforeEnter: () => {
          window.location.replace('/v2/news/list.html');
          return false;
        },
        component: () => import('@template/page/news/news.vue')
      },
      {
        path: RouterEnum.NewsDetail,
        name: 'router.newsDetail',
        beforeEnter: (to) => {
          const id = typeof to.query.id === 'string' && /^\d+$/.test(to.query.id) ? to.query.id : '';

          window.location.replace(id ? `/v2/news/${ id }.html` : '/v2/news/list.html');
          return false;
        },
        component: () => import('@template/page/news/newsDetail.vue')
      },
      //----- 新闻 End -----//
      
      {
        path: RouterEnum.License,
        name: 'router.license',
        component: () => import('@template/page/license/license.vue')
      }
    ]
  },
  {
    path: RouterEnum.Book,
    redirect: Config.Template.default,
    name: 'router.book',
    component: () => import('@template/book/index.vue'),
    children: [
      {
        path: RouterEnum.BookIndustry,
        name: 'router.bookIndustry',
        component: () => import('@template/book/industry/industry.vue')
      },
      {
        path: RouterEnum.BookCostOptimization,
        name: 'router.bookCostOptimization',
        component: () => import('@template/book/costOptimization/costOptimization.vue')
      },
      {
        path: RouterEnum.BookDevOps,
        name: 'router.bookDevOps',
        component: () => import('@template/book/devOps/devOps.vue')
      }
    ]
  },
  // {
  //   path: RouterEnum.OverseasEN,
  //   redirect: RouterEnum.OverseasENHome,
  //   name: 'router.overseasEN',
  //   component: () => import('@template/overseas/index.vue'),
  //   children: [
  //     {
  //       path: RouterEnum.OverseasENHome,
  //       name: 'router.overseasENHome',
  //       component: () => import('@template/overseas/home/home.vue')
  //     }
  //   ]
  // },
  {
    path: RouterEnum.All,
    redirect: Config.Template.default,
    name: 'router.default'
  }
];

/**
 * 路由
 */
const canonicalPath = canonicalSpaPath(location.pathname, RouterList);
if (canonicalPath !== location.pathname) {
  history.replaceState(history.state, '', canonicalPath + location.search + location.hash);
}

export default createRouter({
  // 页面统一使用根路径；旧 /v2/ SPA 地址原地规范化，静态资源目录保持兼容。
  // news 栏目由 scripts/generate-news.mjs 生成静态页
  history: createWebHistory('/'),
  routes: RouterList,
  scrollBehavior(to: any, from: any) {
    // Language changes update the current view, without moving the visitor.
    if (to.path === from.path && to.hash === from.hash && to.query.lang !== from.query.lang &&
      [...new Set([...Object.keys(to.query), ...Object.keys(from.query)])]
        .every(key => key === 'lang' || JSON.stringify(to.query[key]) === JSON.stringify(from.query[key]))) return false;
    if (to.hash) {
      // 锚点滚动由布局组件 book/index.vue 的 scrollAnchor 统一处理
      return false;
    }
    return { top: 0 };
  }
} as RouterOptions);
